import React from 'react';
import './index.css';

// const propTypes = {
//     onClick: PropTypes.func,
//     label: PropTypes.string,
//     title: PropTypes.string,
// };

// const defaultProps = {
//     onClick: () => {},
//     label: '',
//     title: '',
// };

function ButtonComp(props) {
    const { label, title, className, type, onClick } = props;

    // const onClick = () => {
    //     //console.log('clicked');
    // };

    return (
        <div>
            <h1>{label}</h1>
            <button color="primary" disabled={props.disabled} type={type} className={className} onClick={onClick}>
                {title}
            </button>
        </div>
    );
}

// ButtonComp.defaultProps = defaultProps;

// ButtonComp.propTypes = propTypes;

export default ButtonComp;
